export enum AuthMethod {
  INPUT,
  CODE,
  PASSWORD
}
